module.exports = __webpack_public_path__ + "img/appstore.34810bd5.svg";